<template>
  <div class="container">
    <loading-component v-if="isLoading" />
    <no-result-component
      v-else-if="computedResults == null || computedResults.length <= 0"
    />
    <div v-else>
      <page-title-component title="Brewer's choice result" :subtitle="competitionName" />
      <section class="section">
        <div class="container">
          <b-table :data="computedResults" ref="table" :striped="true">
            <template slot-scope="props">
              <b-table-column field="voteCount" label="Votes">{{ props.row.voteCount }}</b-table-column>
              <b-table-column field="brewer" label="Brewer">{{ props.row.brewer }}</b-table-column>
              <b-table-column field="brewName" label="Brew">{{ props.row.brewName }}</b-table-column>
              <b-table-column field="displayNumber" label="Number">{{ props.row.displayNumber }}</b-table-column>
            </template>
          </b-table>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import apiService from "./../services/apiService";
import LoadingComponent from "./Loading.vue";
import NoResultComponent from "./NoResult.vue";
import PageTitleComponent from "./PageTitle.vue";
export default {
  name: "brewers-choice-result",
  components: {
    LoadingComponent,
    NoResultComponent,
    PageTitleComponent
  },
  props: {
    competitionId: String,
    competitionName: String,
    apiKey: String
  },

  data() {
    return {
      isLoading: false,
      results: []
    };
  },
  async created() {
    this.isLoading = true;
    try {
      await this.fetch();
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async fetch() {
      var self = this;
      if (this.apiKey) {
        var managerToken = {
          competitionId: this.competitionId,
          apiKey: this.apiKey
        };
        apiService
          .getBrewersChoiceResult(managerToken)
          .then(response => {
            this.$toast.open({
              message: "Brewer's choice result fetched",
              type: "is-success",
              position: "is-bottom"
            });
            self.results = response.data;
          })
          .catch(err => {
            this.$toast.open({
              message: err.response.data,
              type: "is-danger",
              position: "is-bottom"
            });
          });
      }
    }
  },
  computed: {
    computedResults() {
      var self = this;
      return self.results;
    }
  }
};
</script>
